<template>
    <div
    class="modal right fade trader-info c-offer-modal"
    id="trader-info"
    tabindex="-1"
    role="dialog"
    aria-labelledby="exampleModalLabel"
    aria-hidden="true"       
    >
    <div class="modal-dialog modal-dialog-centered modal-md yldCal" role="document">
        <div class="modal-content">
        <div class="modal-header">
            <h5 class="modal-title" >Yield Calculator</h5>
            <div class="float-right">
            <!-- <button class="btn btn-light" type="button" @click="$emit('close')">Cancel</button> -->
            <!-- <button class="btn btn-primary" type="button" @click="updateYieldToOffer()">Update Yield</button> -->
            <button type="button" class="close" @click="updateYieldToOffer()"><span aria-hidden="true">×</span></button>
            </div>
        </div>
        <div class="modal-body">
            <!-- <div v-if="!secMasterAvailable" style="color: orange;">
                    <span>Security master fields are not available to calculate yield.</span>
                </div> -->
            <form @submit.prevent="">
                
                <div class="form-row">
                    <div class="form-group col-md-4">
                        <label for="Par">Price</label>
                        <input type="number" step="any" v-model.number="price" class="form-control" id="priceval" placeholder="0.00" >
                    </div>
                    <div class="form-group col-md-4" style="margin-top:20px">
                        <label for="Par"></label>
                        <button @click="getYieldValue()" class="btn btn-primary btn-sm set">Calculate Yield</button>
                    </div>
                        <div class="form-group col-md-4">
                        <label for="Par">Calc Yield</label>
                        <input type="number" step="any" v-model.number="calculatedYield"   class="form-control" id="calcyield" placeholder="0.00" >
                    </div>
                </div>
                <div class="form-row">
                    <div class="form-group col-md-4">
                        <label for="Par">Yield</label>
                        <input type="number" step="any" v-model.number="yieldValue" class="form-control" id="priceval" placeholder="0.00" >
                    </div>
                    <div class="form-group col-md-4" style="margin-top:20px">
                        <label for="Par"></label>
                        <button @click="getPriceValue()" class="btn btn-primary btn-sm set">Calculate Price</button>
                    </div>
                        <div class="form-group col-md-4">
                        <label for="Par">Calc Price</label>
                        <input type="number" step="any" v-model.number="calculatedPrice"   class="form-control" id="calcyield" placeholder="0.00" >
                    </div>
                </div>
                <div class="form-row">
                    <div class="form-group col-md-2 ">
                        <label for="bid">Bid</label>
                        <input type="number" class="form-control" id="bid" placeholder="0.00"  step="any" v-model.number="calculate.bid" >
                    </div>
                    <div class="form-group col-md-2">
                        <label for="ask">Ask</label> 
                        <input type="number" class="form-control" id="ask" placeholder="0.00"  step="any" v-model.number="calculate.ask" >
                    </div>
                    <div class="form-group col-md-4 cal-rgt">
                        <label for="settilement">Settilement</label>
                        <datepicker v-model="calculate.settlement" placeholder="mm/dd/yyyy" typeable name="settlement" format="MM/dd/yyyy" :clear-button="true" :calendar-button="true" calendar-button-icon="fas fa-calendar-alt datepicker_icon"></datepicker>
                    </div>
                    <div class="form-group col-md-3">
                        <label for="coupon">Coupon</label> 
                        <input type="number" class="form-control" id="coupon" placeholder="0.00"  step="any" v-model.number="calculate.coupon" >
                    </div>
                </div>
                <div class="form-row justify-content-start">
                    <div class="form-group col-md-3 ">
                        <div class="form-check">
                            <input class="form-check-input" type="checkbox" name="callcheck" id="call" v-model="calculate.call" >
                            <label class="form-check-label" for="callcheck">
                                Call
                            </label>
                        </div>
                    </div>
                    <div class="form-group col-md-3">
                        <div class="form-check">
                            <input class="form-check-input" type="checkbox" name="putcheck" id="putcheck" v-model="calculate.put"  >
                            <label class="form-check-label" for="putcheck">
                                Put
                            </label>
                        </div>
                    </div>
                </div>
                <hr>
                <div class="form-row">
                    <div class="form-group col-md-4">
                        <label for="Maturity">Maturity</label>
                        <datepicker v-model="calculate.maturitydate" placeholder="mm/dd/yyyy" typeable name="maturitydate" format="MM/dd/yyyy" :clear-button="true" :calendar-button="true" calendar-button-icon="fas fa-calendar-alt datepicker_icon"></datepicker>
                    </div>
                    <div class="form-group col-md-4">
                        <label for="Price">Price</label> 
                        <input type="number" class="form-control" id="Price" placeholder="0.00"  step="any" v-model.number="calculate.maturityPrice" >
                    </div>
                    <div class="form-group col-md-4">
                        <label for="value">Value</label> 
                        <input type="number"  step="any" v-model.number="result.newMat"  class="form-control" id="value" placeholder="0.00"  >
                    </div>
                </div>
                <hr>
                <div class="form-row">
                    <div class="form-group col-md-4">
                        <label for="Call">Call</label>
                        <datepicker v-model="calculate.nextCall"  placeholder="mm/dd/yyyy" typeable name="maturitydate" format="MM/dd/yyyy" :clear-button="true" :calendar-button="true" calendar-button-icon="fas fa-calendar-alt datepicker_icon"></datepicker>
                    </div>
                    <div class="form-group col-md-4">
                        <label for="Price">Price</label> 
                        <input type="number" class="form-control" id="callPrice" placeholder="0.00" step="any" v-model.number="calculate.callPrice"  >
                    </div>
                    <div class="form-group col-md-4">
                        <label for="value">Value</label> 
                        <input type="number" step="any" v-model.number="result.newCall" class="form-control" id="callvalue" placeholder="0.00">
                    </div>
                    
                </div>
                <div class="form-row">
                    <div class="form-group col-md-4">
                        <label for="Par">Par</label>
                        <datepicker v-model="calculate.parDate" placeholder="mm/dd/yyyy" typeable name="maturitydate" format="MM/dd/yyyy" :clear-button="true" :calendar-button="true" calendar-button-icon="fas fa-calendar-alt datepicker_icon"></datepicker>
                    </div>
                    <div class="form-group col-md-4">
                        <label for="Price">Price</label> 
                        <input type="number" class="form-control" id="ParPrice" placeholder="0.00" step="any" v-model.number="calculate.parPrice"   >
                    </div>
                    <div class="form-group col-md-4">
                        <label for="value">Value</label> 
                        <input type="number" step="any" v-model.number="result.newPar" class="form-control" id="Parvalue"  placeholder="0.00" >
                    </div>
                </div>
                <div class="form-row">
                    <div class="form-group col-md-4">
                        <label for="Par">PreRe</label>
                        <datepicker v-model="calculate.preRefundedDate"   placeholder="mm/dd/yyyy" typeable name="maturitydate" format="MM/dd/yyyy" :clear-button="true" :calendar-button="true" calendar-button-icon="fas fa-calendar-alt datepicker_icon"></datepicker>
                    </div>
                    <div class="form-group col-md-4">
                        <label for="Price">Price</label> 
                        <input type="number" class="form-control" id="PreRePrice" placeholder="0.00" step="any" v-model.number="calculate.preRefundedPrice"  >
                    </div>
                    <div class="form-group col-md-4">
                        <label for="value">Value</label> 
                        <input type="number" step="any" v-model.number="result.newPreRe" class="form-control" id="PreRevalue"  placeholder="0.00" >
                    </div>
                </div>
                    <div class="form-row">
                    <div class="form-group col-md-4">
                        <label for="Par">ETM</label>
                        <datepicker  v-model="calculate.escrowToMaturityDate"  placeholder="mm/dd/yyyy" typeable name="maturitydate" format="MM/dd/yyyy" :clear-button="true" :calendar-button="true" calendar-button-icon="fas fa-calendar-alt datepicker_icon"></datepicker>
                    </div>
                    <div class="form-group col-md-4">
                        <label for="Price">Price</label> 
                        <input step="any" v-model.number="calculate.escrowToMaturityPrice" type="number" class="form-control" id="etmPrice" placeholder="0.00" >
                    </div>
                    <div class="form-group col-md-4">
                        <label for="value">Value</label> 
                        <input type="number" step="any" v-model.number="result.newEscrow" class="form-control" id="etmvalue" placeholder="0.00" >
                    </div>
                </div>
                <hr>
                    <div class="form-row">
                    <div class="form-group col-md-4">
                        <label for="Par">Put</label>
                        <datepicker v-model="calculate.putDate"   placeholder="mm/dd/yyyy" typeable name="maturitydate" format="MM/dd/yyyy" :clear-button="true" :calendar-button="true" calendar-button-icon="fas fa-calendar-alt datepicker_icon"></datepicker>
                    </div>
                    <div class="form-group col-md-4">
                        <label for="Price">Price</label> 
                        <input type="number" class="form-control" id="putPrice" placeholder="0.00" step="any" v-model.number="calculate.putPrice"  >
                    </div>
                    <div class="form-group col-md-4">
                        <label for="value">Value</label> 
                        <input type="number" step="any" v-model.number="result.newPut" class="form-control" id="putvalue"  placeholder="0.00">
                    </div>
                </div>
                    <div class="form-row">
                    <div class="form-group col-md-4">
                        <label for="Par">Mand</label>
                        <datepicker v-model="calculate.mandDate"   placeholder="mm/dd/yyyy" typeable name="maturitydate" format="MM/dd/yyyy" :clear-button="true" :calendar-button="true" calendar-button-icon="fas fa-calendar-alt datepicker_icon"></datepicker>
                    </div>
                    <div class="form-group col-md-4">
                        <label for="Price">Price</label> 
                        <input type="number" class="form-control" id="mandPrice"  placeholder="0.00" step="any" v-model.number="calculate.mandprice">
                    </div>
                    <div class="form-group col-md-4">
                        <label for="value">Value</label> 
                        <input type="number" step="any" v-model.number="result.newMand" class="form-control" id="mandvalue" placeholder="0.00" >
                    </div>
                </div>
                <div v-if="loading" style="height:0px">
                        <img src="@/assets/img/loader.svg" alt=""/>
                    </div>
                <hr>
                
                
                <!-- <div class="form-row">
                    <div class="form-group col-md-6">
                        <label for="Par">Calc Yield</label>
                        <input type="number"  class="form-control" id="calcyield" placeholder="0.00" >
                    
                    </div>
                    <div class="form-group col-md-6">
                        <label for="Price">Calc Price</label> 
                        <input type="number" class="form-control" id="calcprice" placeholder="0.00" >
                    </div>
                </div> -->




            </form>    
            <div v-if="loading" class="loader"><img src="@/assets/img/loader.svg" alt=""/></div>
            <!-- <p v-if="error">
                <ul>
                <li class="alert alert-danger" role="alert">Account number is required.</li>
                </ul>
            </p> -->
            
        </div>
        </div>
    </div>
    </div>
</template>

<script>
import authService from "@/authService";
import config from "@/config";
import Datepicker from 'vuejs-datepicker';
export default {
    name: 'yieldcalc',
    components :{
        Datepicker
    },
    props: ['offerPrice','offerYield','cusipid','settlementDate'],
    data() {
        return {
            loading : false,
            calculate : {},
            price : this.offerPrice,
            calulatedYield : 0,
            yieldValue : this.offerYield,
            result : {},
            calculatedYield : 0,
            calculatedPrice : 0,
            secMasterAvailable : true

        };
    },
    methods: {   
        getYieldValue(){
        this.loading = true;
        // const auth = {
        //   headers: {'Access-Control-Allow-Origin': '*','Access-Control-Allow-Credentials' : true}
        // };
        let data = {};
            data.price = this.price+"";
            data.settlement = this.calculate.settlement ? this.moment(this.calculate.settlement).format("MM/DD/YYYY") : "null";
            data.maturitydate = this.calculate.maturitydate ? this.moment(this.calculate.maturitydate).format("MM/DD/YYYY") : "null";
            data.yield = "";
            data.coupon = this.calculate.coupon;
            data.callPrice = this.calculate.callPrice || 0;
            data.maturityPrice = this.calculate.maturityPrice || 0;
            data.parPrice = this.calculate.parPrice || 0;
            data.preRefundedPrice = this.calculate.preRefundedPrice || 0;
            data.escrowToMaturityPrice = this.calculate.escrowToMaturityPrice || 100;
            data.call = this.calculate.call;
            data.put = this.calculate.put;
            data.putPrice = this.calculate.putPrice || 0;
            data.mandprice = this.calculate.mandprice || 0;
    
            data.preRefundedDate = this.calculate.preRefundedDate ? this.moment(this.calculate.preRefundedDate).format("MM/DD/YYYY") : "null";
            data.escrowToMaturityDate = this.calculate.escrowToMaturityDate ? this.moment(this.calculate.escrowToMaturityDate).format("MM/DD/YYYY") : "null"
            data.parDate = this.calculate.parDate ? this.moment(this.calculate.parDate).format("MM/DD/YYYY") : "null";
            data.putDate = this.calculate.putDate ? this.moment(this.calculate.putDate).format("MM/DD/YYYY") : "null";
            data.mandDate = this.calculate.mandDate ?  this.moment(this.calculate.mandDate).format("MM/DD/YYYY") : "null";
            data.nextCall = this.calculate.nextCall ? this.moment(this.calculate.nextCall).format("MM/DD/YYYY") : "null";
            //console.log(data);
        this.$http
        .post(
            config.baseUrlBidSide +
            "/yield/calculation ",
            data
        )
        .then((res) => {
            this.loading = false;
            this.result = res.data;
            this.calculatedYield = this.result.calcPrice.toFixed(3);
            this.result.newMat = this.result.newMat.toFixed(3);
            this.result.newCall = this.result.newCall.toFixed(3);
            this.result.newPar = this.result.newPar.toFixed(3);
            this.result.newPreRe =  this.result.newPreRe.toFixed(3);
            this.result.newEscrow = this.result.newEscrow.toFixed(3);
            this.result.newPut = this.result.newPut.toFixed(3);
            this.result.newMand =  this.result.newMand.toFixed(3);
        }).catch(() => this.loading = false) 
        },
        getPriceValue(){
        this.loading = true;
        // const auth = {
        //   headers: {'Access-Control-Allow-Origin': '*','Access-Control-Allow-Credentials' : true}
        // };
        let data = {};
            data.price = "";
            data.settlement = this.calculate.settlement ? this.moment(this.calculate.settlement).format("MM/DD/YYYY") : "null";
            data.maturitydate = this.calculate.maturitydate ? this.moment(this.calculate.maturitydate).format("MM/DD/YYYY") : "null";
            data.yield = this.yieldValue;
            data.coupon = this.calculate.coupon;
            data.callPrice = this.calculate.callPrice || 0;
            data.maturityPrice = this.calculate.maturityPrice || 0;
            data.parPrice = this.calculate.parPrice || 0;
            data.preRefundedPrice = this.calculate.preRefundedPrice || 0;
            data.escrowToMaturityPrice = this.calculate.escrowToMaturityPrice || 100;
            data.call = this.calculate.call;
            data.put = this.calculate.put;
            data.putPrice = this.calculate.putPrice || 0;
            data.mandprice = this.calculate.mandprice || 0;
    
            data.preRefundedDate = this.calculate.preRefundedDate ? this.moment(this.calculate.preRefundedDate).format("MM/DD/YYYY") : "null";
            data.escrowToMaturityDate = this.calculate.escrowToMaturityDate ? this.moment(this.calculate.escrowToMaturityDate).format("MM/DD/YYYY") : "null"
            data.parDate = this.calculate.parDate ? this.moment(this.calculate.parDate).format("MM/DD/YYYY") : "null";
            data.putDate = this.calculate.putDate ? this.moment(this.calculate.putDate).format("MM/DD/YYYY") : "null";
            data.mandDate = this.calculate.mandDate ?  this.moment(this.calculate.mandDate).format("MM/DD/YYYY") : "null";
            data.nextCall = this.calculate.nextCall ? this.moment(this.calculate.nextCall).format("MM/DD/YYYY") : "null";
            //console.log(data);
        this.$http
        .post(
            config.baseUrlBidSide +
            "/yield/calculation-price ",
            data
        )
        .then((res) => {
            this.loading = false;
            this.result = res.data;
            this.calculatedPrice = this.result.calcPrice.toFixed(3);
            this.result.newMat = this.result.newMat.toFixed(3);
            this.result.newCall = this.result.newCall.toFixed(3);
            this.result.newPar = this.result.newPar.toFixed(3);
            this.result.newPreRe =  this.result.newPreRe.toFixed(3);
            this.result.newEscrow = this.result.newEscrow.toFixed(3);
            this.result.newPut = this.result.newPut.toFixed(3);
            this.result.newMand =  this.result.newMand.toFixed(3);
        }).catch(() => this.loading = false) 
        },
        updateYieldToOffer(){
        //console.log("ds",this.calculatedYield,this.calculatedPrice)
        this.$emit('yieldupdate',this.calculatedYield ? this.calculatedYield : 0);
        if(this.calculatedPrice != '0.000' ){
            this.$emit('priceupdate',this.calculatedPrice ? this.calculatedPrice : 0);
        }
        this.$emit('close');
        },
        getCusipDetails(){
        this.loading = true;
        const auth = {
            headers: {'org-token' : authService.getOrgToken() }
            };           
        this.$http
        .get(
            config.baseUrlBidSide +
            "/cusip/"+this.cusipid+"?showCalculationInput=true",auth
        )
        .then((result) => {
            this.loading = false;
            let calculationInput = result.data.calculationInput
            // result.data.coupon = result.data.secMasterCoupon ?  result.data.secMasterCoupon : calculationInput.coupon;
            this.calculate.coupon = calculationInput.coupon;
            this.calculate.call = calculationInput.call ? true : false;
            this.calculate.put = calculationInput.put ? true : false;
            this.calculate.maturitydate = calculationInput.maturitydate;
            this.calculate.maturityPrice = calculationInput.maturityPrice;
            this.calculate.nextCall = calculationInput.nextCall;
            this.calculate.callPrice = calculationInput.callPrice;
            this.calculate.parDate = calculationInput.parDate;
            this.calculate.parPrice = calculationInput.parPrice;
            this.calculate.putDate = calculationInput.putDate;
            this.calculate.putPrice = calculationInput.putPrice;
            this.calculate.mandDate = calculationInput.mandDate;
            this.calculate.mandprice = calculationInput.mandprice;
            this.calculate.escrowToMaturityDate = calculationInput.escrowToMaturityDate ;
            this.calculate.preRefundedDate = calculationInput.preRefundedDate;
            this.calculate.escrowToMaturityPrice = calculationInput.escrowToMaturityPrice ;
            this.calculate.preRefundedPrice = calculationInput.preRefundedPrice;

            this.calculate.bid = result.data.bidPrice;
            this.calculate.ask = result.data.askPrice;
            this.calculate.settlement = this.settlementDate;
            this.secMasterAvailable = result.data.isSecurityMasterExist;
            
        })
        }
    },
    mounted() {
        this.getCusipDetails()
    }
};
</script>